import { Outlet } from "react-router-dom";
import Navigation from "./features/navigation";

export default function RootLayout() {
  return (
    <div className="container">
      <Navigation />
      <div className="page-wrapper">
        <div className="content-wrapper">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
